(function () {
  class GigabloxFactory extends PIXI.Container {
    constructor() {
      super();
      this._slotMachineMap = {};
      this._slotMachineTemplateData = {};
      this._reelVisualTemplateData = {};
      this._slamStopRequested = false;
      this._receivedTargetPositions = false;
      this._windowBlockInfo = [];
      this._currentRowCount = 0;
      this._stopData = {
        requested: false,
      };
      this._reelVisualParent = undefined;
      this._currentMode = 'default';
      this._sourceSlotMachine = {
        sm: undefined,
        parent: undefined,
        layout: [],
      };

      this._activeSlotMachine = {
        sm: undefined,
        parent: undefined,
        layout: [],
        bounds: undefined,
      };

      this._inGrowTransition = false;

      this._wipeCB = undefined;

      this.createStates();

      let self = this;
      Reflex.addToUpdate(function (delta) {
        // closeures are faster than binds. Updates are called every frame so i pick performance over code prettiness
        self.update(delta);
      });

      this._boundNewSymbol = this.onNewTransitionSymbol.bind(this);

      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));

      this._trackLandEvents = {};
      this._trackHitEvents = {};
    }

    onOrientationChange() {
      if (this._inGrowTransition) {
        this.stateMachine.switchState('IDLE');
      }

      this.resetSlotParentPosition();
    }

    resetSlotParentPosition() {
      /*
            
            if(this._activeSlotMachine && this._activeSlotMachine.sm) {
                let minSymbolSpacing = this._activeSlotMachine ? this._activeSlotMachine.sm.getMinSymbolSpacing(0) : this._sourceSlotMachine.sm.getMinSymbolSpacing(0);
                let appertureHeight = this._currentRowCount;

                let isLandscape = layoutController.getCurrentLayoutProperties().landscape;
                let entry = isLandscape ? this._appertureHeightScales.landscape[appertureHeight] : this._appertureHeightScales.portrait[appertureHeight];

                let offset = (appertureHeight - 4) * minSymbolSpacing;    // magic number 4, it is the default number of rows before they start growing
                let endScale = entry.scale;
                let yOffset = entry.y;

                if (this._activeSlotMachine)
                    this.setParentScale(this._activeSlotMachine.parent, endScale, this._activeSlotMachine.bounds, offset - yOffset);
                //  if (this._sourceSlotMachine && this._sourceSlotMachine.parent)
                //     this.setParentScale(this._sourceSlotMachine.parent, endScale, this._sourceSlotMachine.bounds, offset - yOffset);
                this.updateClipRect(0, appertureHeight * minSymbolSpacing, this._activeSlotMachine);
            }
            */

      let slotMachines = [this._sourceSlotMachine, this._activeSlotMachine];
      for (let i = 0; i < slotMachines.length; ++i) {
        let slotMachine = slotMachines[i];
        if (slotMachine && slotMachine.sm) {
          let minSymbolSpacing = slotMachine.sm.getMinSymbolSpacing(0);
          let appertureHeight = this._currentRowCount;

          let isLandscape = layoutController.getCurrentLayoutProperties().landscape;
          let entry = isLandscape
            ? this._appertureHeightScales.landscape[appertureHeight]
            : this._appertureHeightScales.portrait[appertureHeight];

          let offset = (appertureHeight - 4) * minSymbolSpacing; // magic number 4, it is the default number of rows before they start growing
          let endScale = entry.scale;
          let yOffset = entry.y;

          if (this._activeSlotMachine.bounds)
            // think the active slot machine is the one with the bounds we want to honour.
            this.setParentScale(slotMachine.parent, endScale, this._activeSlotMachine.bounds, offset - yOffset);
          //  if (this._sourceSlotMachine && this._sourceSlotMachine.parent)
          //     this.setParentScale(this._sourceSlotMachine.parent, endScale, this._sourceSlotMachine.bounds, offset - yOffset);
          this.updateClipRect(0, appertureHeight * minSymbolSpacing, slotMachine);
        }
      }
    }

    createStates() {
      StateMachine.Create(this);
      let self = this;
      this.stateMachine.addState('IDLE', function () {});
      this.stateMachine.addState('TRANSITION', function () {
        self.state_transition();
      });
      this.stateMachine.addState('GROW', function () {
        self.state_grow();
      });
      this.stateMachine.addState('WIPE', function () {
        self.state_wipe();
      });
      this.stateMachine.addState('CHANGEROWS', function () {
        self.state_change_rows();
      });
      this.stateMachine.addState('SHRINKROWS', function () {
        self.state_shrink_rows();
      });
    }

    initialise(json) {
      this._reelVisualParent = resourceManager.get(json.visualParent);
      if (!this._reelVisualParent) {
        console.log('Cannot find reel visual parent');
      }
      this._slotMachineTemplateData = json.slotMachineTemplateData;
      this._reelVisualTemplateData = json.reelVisualTemplateData;
    }

    setAppertureData(appertureData) {
      this._appertureHeightScales = appertureData;
    }

    getAppertureData() {
      return this._appertureHeightScales;
    }

    getSymbolsInWindow() {
      return this._activeSlotMachine.sm.getSymbolsInWindow();
    }

    createNewSlotMachine(gigabloxLayout, stringRespresentation, appertureHeight) {
      // create a parent for all reels, makes it easier to show and hide etc
      let container = resourceManager.createObject(
        'container',
        'container' + stringRespresentation,
        this._reelVisualParent
      );
      container.mask = new PIXI.Graphics();
      container.addChild(container.mask);

      // create the slotMachine for this layout
      resourceManager.controllerInstances[stringRespresentation] =
        resourceManager.registeredControllers['SlotMachineEx']();
      resourceManager.controllerInstances[stringRespresentation].name = stringRespresentation;
      this._slotMachineMap[stringRespresentation] = container;

      // create all the reels...
      let reelCount = 0;
      for (let i = 0; i < gigabloxLayout.length; ++i) {
        let blockSize = gigabloxLayout[i].length;
        let reelTemplateClone = JSON.parse(JSON.stringify(this._reelVisualTemplateData));
        reelTemplateClone.appertureHeight = appertureHeight;
        reelTemplateClone.slotMachineName = stringRespresentation;
        reelTemplateClone.ID = 'reel' + i;
        reelTemplateClone.reelIndex = i;
        reelTemplateClone.clipRect.width *= blockSize;
        reelTemplateClone.landscape_default.position.x = reelTemplateClone.minSymbolSpacing * reelCount;
        reelTemplateClone.landscape_mobile.position.x = reelTemplateClone.minSymbolSpacing * reelCount;
        reelTemplateClone.portrait_default.position.x = reelTemplateClone.minSymbolSpacing * reelCount;
        reelTemplateClone.portrait_mobile.position.x = reelTemplateClone.minSymbolSpacing * reelCount;
        reelCount += blockSize;
        reelTemplateClone.blockSize = blockSize;
        let rsvg = resourceManager.createObject(
          'ReelSpinnerVisualGigablox',
          stringRespresentation + ':Reel_' + i,
          container,
          reelTemplateClone
        );
        rsvg.assignSlotMachine(resourceManager.controllerInstances[stringRespresentation]);
      }

      // holy nested for loops batman
      let slotTemplateClone = JSON.parse(JSON.stringify(this._slotMachineTemplateData));
      //        for(let prop in slotTemplateClone.modes){
      const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
      let prop = 'defaultSettings';
      if (slotTemplateClone.hasOwnProperty(prop)) {
        for (let i = 0; i < gigabloxLayout.length; ++i) {
          let blockSize = gigabloxLayout[i].length;
          //    for (let reel = 0; reel < slotTemplateClone[prop].injectorRules.length; ++reel){
          for (let type = 0; type < slotTemplateClone[prop].injectorRules[i].length; ++type) {
            if (slotTemplateClone[prop].injectorRules[i][type].type === 'group') {
              for (let rule = 0; rule < slotTemplateClone[prop].injectorRules[i][type].rules.length; ++rule) {
                for (let symbolId in slotTemplateClone[prop].injectorRules[i][type].rules[rule]) {
                  if (slotTemplateClone[prop].injectorRules[i][type].rules[rule].hasOwnProperty(symbolId)) {
                    if (symbolId == bonusID) {
                      // bonus ids stay as 1 size
                      // perhaps a better config setting for this
                      slotTemplateClone[prop].injectorRules[i][type].rules[rule][symbolId].count = 1;
                    } else {
                      slotTemplateClone[prop].injectorRules[i][type].rules[rule][symbolId].count = blockSize;
                    }
                  }
                }
              }
            }
          }
        }
        //}
      }
      //   }
      // initialise slot machine now it has all reels
      resourceManager.controllerInstances[stringRespresentation].initialise(slotTemplateClone);

      // setup bounds
    }

    trackSymbolId(reelId, symbolId, onTrackCb, onUntrackedCb) {
      return this._activeSlotMachine.sm.trackSymbolId(reelId, symbolId, onTrackCb, onUntrackedCb);
    }

    trackSymbolInWindow(reelId, row, symbolId, onTrackCb, onUntrackedCb) {
      return this._activeSlotMachine.sm.trackSymbolInWindow(reelId, row, symbolId, onTrackCb, onUntrackedCb);
    }

    removeSymbolTracker(reelId, uniqueSymbolId) {
      this._activeSlotMachine.sm.removeSymbolTracker(reelId, uniqueSymbolId);
    }

    getStartingSymbols(layout, preInjectors, appertureSize) {
      let res = [];
      const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;

      for (let i = 0; i < layout.length; ++i) {
        let reelSymbols = [];
        let lastSymbolId = -1;
        let blockLength = layout[i].length;
        let symbolId = -1;
        for (let j = 0; j < appertureSize; ) {
          do {
            symbolId = preInjectors[i].getRandomSymbol([], 1, -1);
          } while (lastSymbolId === symbolId || symbolId === 0 || symbolId === bonusID);
          lastSymbolId = symbolId;

          let numLeft = Math.min(blockLength, appertureSize - j);

          for (let k = 0; k < numLeft; ++k) {
            reelSymbols.push({ value: symbolId });
          }
          j += numLeft;
        }

        res.push({ symbols: reelSymbols });
      }

      return res;
    }

    getReelScreenPosition(reelIdx) {
      let position = this._reelVisualParent.position;
      let res = {
        x: position.getX(),
        y: position.getY(),
      };

      res.x += reelIdx * this._reelVisualTemplateData.minSymbolSpacing * this.getCurrentScale();
      return res;
    }

    getCurrentScale() {
      return this._activeSlotMachine.parent.scale.x;
    }

    getBounds() {
      let pos = this.getReelScreenPosition(0);
      return {
        x: pos.x,
        y: pos.y,
        width: this._activeSlotMachine.bounds.width,
        height: this._activeSlotMachine.bounds.height,
      };
    }

    setCurrentMode(mode) {
      this._currentMode = mode;
      this._activeSlotMachine.sm.selectReelMode(this._currentMode);
    }

    preGrow(numRowCount, startData, endData, winEvent, cb) {
      if (this._currentRowCount === numRowCount) return;

      this._changeWindowSizeData = {
        startData: startData,
        endData: endData,
        callback: null,
        winEvent: winEvent,
      };

      this._currentRowCount = numRowCount;

      // we will always be here with a win so clear split blocks
      this.clearSplitBlocks();

      let currentLayout = this.getCurrentLayout();

      this.dimAllSymbols(false, 0.0);
      this.unsubscribeToReelsLandedEvent(this._activeSlotMachine.sm, this._stopData.reelLandCB);
      this.unsubscribeToReelsHitEvent(this._activeSlotMachine.sm, this._stopData.reelHitCB);

      this.reassignSlotMachine(this._activeSlotMachine, this._sourceSlotMachine);
      this.switchActiveLayout(currentLayout, this._currentRowCount);

      this.subscribeToReelsLandedEvent(this._activeSlotMachine.sm, this._stopData.reelLandCB);
      this.subscribeToReelsHitEvent(this._activeSlotMachine.sm, this._stopData.reelHitCB);

      this.unveilClipRect(this._activeSlotMachine.parent, 1, this._activeSlotMachine.bounds);
      let sourceAppertureHeight = this._sourceSlotMachine.sm.reels[0].getCurrentAppertureHeight();

      let startingSymbols = [];
      // grow
      if (sourceAppertureHeight < this._currentRowCount) {
        startingSymbols = this.copySymbolIdsFromSourceToActive(
          currentLayout.length,
          0,
          1,
          sourceAppertureHeight,
          this._sourceSlotMachine.sm,
          this._activeSlotMachine.sm
        );
        // preapperture of source begine symbol 0 for sctive
        for (let reelId = 0; reelId < currentLayout.length; ++reelId)
          startingSymbols[reelId].symbols.unshift({
            value: this._sourceSlotMachine.sm.getSymbolId(reelId, sourceAppertureHeight),
          });
      } // shrink
      else
        startingSymbols = this.copySymbolIdsFromSourceToActive(
          currentLayout.length,
          sourceAppertureHeight - this._currentRowCount,
          0,
          this._currentRowCount,
          this._sourceSlotMachine.sm,
          this._activeSlotMachine.sm
        );

      let simpleWindowSymbols = [];
      for (let i = 0; i < startingSymbols.length; ++i) {
        let simpleReelSymbols = [];
        let appertureHeight = this._activeSlotMachine.sm.reels[i].getCurrentAppertureHeight();
        for (let j = 0; j < appertureHeight; ++j) {
          simpleReelSymbols.push(startingSymbols[i].symbols[j].value);
        }
        simpleWindowSymbols.push(simpleReelSymbols);
      }

      let minSymbolSpacing = this._activeSlotMachine.sm.getMinSymbolSpacing(0);
      let offset = (this._currentRowCount - 4) * minSymbolSpacing; // magic number 4, it is the default number of rows before they start growing

      //        this._activeSlotMachine.parent.y = -offset;
      this.setParentScale(
        this._activeSlotMachine.parent,
        this._changeWindowSizeData.startData.scale,
        this._activeSlotMachine.bounds,
        offset
      );

      // recalculate block data
      this._windowBlockInfo = this.calcWindowBlockInfo(simpleWindowSymbols, currentLayout);
      this.addAppertureSymbol(startingSymbols, this._windowBlockInfo);
      this.setStartingSymbols(startingSymbols, this._activeSlotMachine.sm);

      for (let i = 0; i < currentLayout.length; ++i) {
        this._activeSlotMachine.sm._reelVisuals[i].redraw();
      }

      this.fullyDiscardSlotMachine(this._sourceSlotMachine);
      this.updateClipRect(offset, (this._currentRowCount - 1) * minSymbolSpacing, this._activeSlotMachine); // set to previous height so it can grow into it

      console.log('=================');
      console.log('Start Scale: ' + this._changeWindowSizeData.startData.scale);

      //        this.splitWinningBlocks(this._changeWindowSizeData.winEvent.winningLines);
    }

    changeSymbolsInWindow(numRowCount, startData, endData, winEvent, cb) {
      //if (this._currentRowCount === numRowCount) return;

      this._changeWindowSizeData = {
        startData: startData,
        endData: endData,
        callback: cb,
        winEvent: winEvent,
      };

      if (this._currentRowCount > numRowCount) this.stateMachine.switchState('SHRINKROWS');
      else this.stateMachine.switchState('CHANGEROWS');
      this._currentRowCount = numRowCount;
    }

    switchActiveLayout(layout, appertureHeight) {
      this.selectSlotMachine(layout, appertureHeight);
      let preInjectors = this._activeSlotMachine.sm._currentMode.preInjectors;
      let startingSymbols = this.getStartingSymbols(layout, preInjectors, appertureHeight);

      let simpleWindowSymbols = [];
      for (let i = 0; i < startingSymbols.length; ++i) {
        let simpleReelSymbols = [];
        for (let j = 0; j < startingSymbols[i].symbols.length; ++j) {
          simpleReelSymbols.push(startingSymbols[i].symbols[j].value);
        }
        simpleWindowSymbols.push(simpleReelSymbols);
      }

      this._windowBlockInfo = this.calcWindowBlockInfo(simpleWindowSymbols, layout);

      this.addAppertureSymbol(startingSymbols, this._windowBlockInfo);

      this.setStartingSymbols(startingSymbols, this._activeSlotMachine.sm);

      // populate the pre symbols with valid symbol info
      // so we dont see a wall of 10's going past
      this.populatePreSymbolsWithRandom(layout);

      //       this._activeSlotMachine.sm.reset();
      //       this._activeSlotMachine.sm.infiniteSpin();
      this.moveSlotMachineToFront(this._activeSlotMachine.parent);
      this.unveilClipRect(this._activeSlotMachine.parent, 0, this._activeSlotMachine.bounds);
    }

    populatePreSymbolsWithRandom(layout) {
      let preInjectors = this._activeSlotMachine.sm._currentMode.preInjectors;
      let preSymbols = this.getStartingSymbols(layout, preInjectors, Globals.NUM_PRE_APPERATURE_SYMBOLS);
      const reelVisuals = this._activeSlotMachine.sm._reelVisuals;
      for (let r = 0; r < preSymbols.length; r++) {
        const symbols = preSymbols[r].symbols.reverse();
        const reelSpinnerData = reelVisuals[r]._reelSpinnerData;
        const offset = Globals.NUM_REELS;
        for (let s = 0; s < symbols.length; s++) {
          reelSpinnerData._symbolData[s + offset].symId = symbols[s].value;
        }
      }
    }

    calcStopDistancesForBonus(originalStopDistances, windowResult, layout) {
      let res = originalStopDistances;

      if (this._currentMode !== 'default') {
        return res;
      }

      const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
      let runningCount = { count: 0, startReel: -1 };
      for (let i = 0; i < windowResult.length; ++i) {
        let reel = windowResult[i];
        for (let j = 0; j < reel.length; ++j) {
          if (reel[j] === bonusID) {
            runningCount.count += layout[i].length;
          }
        }
        if (runningCount.count >= 2) {
          res[i] = 70;
        }
      }
      return res;
    }

    calcStopDistancesForBonusForBigBlock(
      originalStopDistances,
      windowResult,
      layout,
      winsPerReel,
      champagneModifierData
    ) {
      let res = originalStopDistances;

      // are we getting champagne?
      if (champagneModifierData?.isAwarded) {
        return res;
      }

      let biggestBlockSize = this.getBiggestBlock(layout);
      if (biggestBlockSize < 3) return res;

      let reelIndex = this.getBiggestBlockReelIndex(layout, biggestBlockSize).localIdx;
      if (reelIndex > 1) {
        return res;
      }

      if (reelIndex > 0) {
        res[reelIndex - 1] = 140;
      } else if (reelIndex === 0) {
        res[0] = 100;
      }

      for (let i = reelIndex; i < layout.length; ++i) {
        if (winsPerReel[i] >= 3) {
          res[i] = 140;
        }
      }

      return res;
    }

    calcWindowBlockInfo(symbols, layout) {
      let res = [];
      for (let i = 0; i < symbols.length; ++i) {
        res.push(this.analyseBlocksOnReel(symbols[i], layout[i].length, i));
      }
      return res;
    }

    stopActiveSlotMachine(
      landCallback,
      verbose,
      result,
      layout,
      above,
      below,
      completeCallback,
      longSpinCB,
      winsPerReel,
      onDoubleWide,
      reelHitCB,
      extraStopDistances,
      champagneModifierData
    ) {
      let self = this;
      this._windowBlockInfo = this.calcWindowBlockInfo(result, layout);
      this.subscribeToReelsLandedEvent(this._activeSlotMachine.sm, landCallback);
      this.subscribeToReelsHitEvent(this._activeSlotMachine.sm, reelHitCB);
      this._activeSlotMachine.sm.setLoggingEnabled(verbose);
      let originalStopDistances = this._activeSlotMachine.sm._currentMode.stopDistances;
      let originalMinSpinTime = this._activeSlotMachine.sm._currentMode.minimumSpinTime;
      let bonusStopDistances = this.calcStopDistancesForBonus(
        JSON.parse(JSON.stringify(originalStopDistances)),
        result,
        layout
      );
      let bigBlockStopDisances = this.calcStopDistancesForBonusForBigBlock(
        JSON.parse(JSON.stringify(originalStopDistances)),
        result,
        layout,
        winsPerReel,
        champagneModifierData
      );
      let stopDistances = JSON.parse(JSON.stringify(originalStopDistances));
      let firstLongSpinReel = result.length;
      let longSpinReason = '';
      for (let i = originalStopDistances.length - 1; i >= 0; --i) {
        let stopDistance = originalStopDistances[i];
        let currentLongSpinReason = '';
        if (bonusStopDistances[i] > stopDistance) {
          stopDistance = bonusStopDistances[i];
          currentLongSpinReason = 'BONUS';
        } else if (bigBlockStopDisances[i] > stopDistance) {
          stopDistance = bigBlockStopDisances[i];
          if (winsPerReel[i] >= 3) {
            currentLongSpinReason = 'BIG_BLOCK_WINS';
          } else {
            currentLongSpinReason = 'BIG_BLOCK';
          }
        }
        stopDistances[i] = stopDistance;
        if (stopDistance > originalStopDistances[i]) {
          firstLongSpinReel = i;
          longSpinReason = currentLongSpinReason;
        }
      }
      let lastLongSpinReel = 0;
      if (firstLongSpinReel < result.length) {
        console.log('*** LONG SPIN REASON: ' + longSpinReason);

        if (longSpinReason === 'BONUS') {
          lastLongSpinReel = layout.length; // all reels spin
          longSpinCB(firstLongSpinReel + 1, longSpinReason, -1);
        } else if (longSpinReason === 'BIG_BLOCK' || longSpinReason === 'BIG_BLOCK_WINS') {
          let biggestBlockSize = this.getBiggestBlock(layout);
          firstLongSpinReel = this.getBiggestBlockReelIndex(layout, biggestBlockSize).localIdx;

          if (firstLongSpinReel === 0) {
            lastLongSpinReel = firstLongSpinReel + 2;
          } else {
            lastLongSpinReel = firstLongSpinReel + 1;
          }

          for (let i = 0; i < stopDistances.length; ++i) {
            if (stopDistances[i] > originalStopDistances[i]) lastLongSpinReel = i + 1;
          }

          //             if (lastLongSpinReel >= this._stopData.symbols.length){
          //                lastLongSpinReel = this._stopData.symbols.length -1;
          //           }

          longSpinCB(firstLongSpinReel, longSpinReason, lastLongSpinReel + 1);

          // hunters moon specific, I want the reels that are no longer long spinning to have a slightly longer land time
          for (let j = firstLongSpinReel + 1; j < originalStopDistances.length; ++j) {
            if (originalStopDistances[j] === stopDistances[j]) {
              stopDistances[j] += 8;
            }
          }

          if (firstLongSpinReel === 0) {
            // we can only do a long spin on the first reel by setting the min spin time, as stopDistance[0] is between first reel landing and second
            // if it is a 6x6 the animation up to this point (grow etc) has taken too long and the anticipation loop has ended (sounds bad) so make the spin shorter
            if (this._stopData.symbols.length === 1) this._activeSlotMachine.sm._currentMode.minimumSpinTime = 4;
            else this._activeSlotMachine.sm._currentMode.minimumSpinTime = 8;
          }
        }
      }

      //  this._activeSlotMachine.sm._currentMode.stopDistances = stopDistances;
      this._activeSlotMachine.sm.stopReels(
        result,
        above,
        below,
        function () {
          self._activeSlotMachine.sm._currentMode.stopDistances = originalStopDistances;
          self._activeSlotMachine.sm._currentMode.minimumSpinTime = originalMinSpinTime;
          completeCallback();
        },
        undefined,
        extraStopDistances
      );

      // so... due to the dynamic timing of the slot machine, for anticipation spins it easily goes over the min spin time,
      // and the slot machine will reduce the stop distances to fit this time, making the spin look really short.
      // The following fixes it

      let oldStopDistances = this._activeSlotMachine.sm._currentMode.stopDistances;
      let anticipationStopDistances = stopDistances;

      let reels = this._activeSlotMachine.sm.reels;
      for (let reelId = 1; reelId < reels.length; ++reelId) {
        // reelId = 1 because we cant anticipate the first reel
        let isAnticipating = reelId > firstLongSpinReel && reelId <= lastLongSpinReel;
        let previousReelTravelDistance = reels[reelId - 1].getInjectors().post.getMinTravelDistance();
        let thisReelTravelDistance = reels[reelId].getInjectors().post.getMinTravelDistance();

        let delta = thisReelTravelDistance - previousReelTravelDistance - oldStopDistances[reelId - 1];
        if (isAnticipating) {
          delta = anticipationStopDistances[reelId - 1] - oldStopDistances[reelId - 1]; // -1 because the stop distances are based on previous to current
          if (delta > 0) {
            let injectors = reels[reelId].getInjectors();
            injectors.post.setMinTravelDistance(previousReelTravelDistance + delta);
          }
        } else if (delta < 0) {
          let injectors = reels[reelId].getInjectors();
          injectors.post.setMinTravelDistance(previousReelTravelDistance + oldStopDistances[reelId]);
        }
      }

      this._receivedTargetPositions = true;
    }

    onNewTransitionSymbolForGrow(layout, growData, reelId) {
      console.log('----In new transition symbol for grow');
      if (reelId === 'reel0' && this._stopData.requested) {
        // all reels are aligned with gigablox, so it doesnt matter why reelId this is as they are all firing new symbols together
        console.log('----inside if statement');
        this._sourceSlotMachine.sm.unsubscribeToNewSymbolEvent(this._boundNewSymbolForGrow);
        this.switchActiveLayout(layout, this._currentRowCount);

        // in order for transitioning of slot machines to align the slot machine must be forced through its state transitoin frames
        // so it starts spinning next frame. Update 0 is fine as we are only interested in moving through states and not moving the
        // symbols by frame delta

        this._activeSlotMachine.sm.infiniteSpin();
        while (this._activeSlotMachine.sm.reels[0].stateMachine.ActiveStateName !== 'INFINITE_SPIN') {
          this._activeSlotMachine.sm.update(0);
        }

        // now move the reel by the same amount that the transtion has moved this frame to keep them aligned...
        this._activeSlotMachine.sm.update(this._sourceSlotMachine.sm.reels[0]._deltaTime);

        let self = this;
        if (this._transitionCallback !== undefined) {
          this._transitionCallback(growData, function () {
            self.fullyDiscardSlotMachine(self._sourceSlotMachine);
            self.unveilClipRect(self._activeSlotMachine.parent, 1.0, self._activeSlotMachine.bounds);
            if (self._growData.length === 0) {
              let delayTime = self.getBigBloxStaggerTimer();
              timerManager.addTimer(delayTime, undefined, function () {
                self.stopActiveSlotMachine(
                  self._stopData.reelLandCB,
                  true,
                  self._stopData.symbols,
                  self._stopData.layout,
                  self._stopData.above,
                  self._stopData.below,
                  self._stopData.spinCompleteCB,
                  self._stopData.longSpinCB,
                  self._stopData.winsPerReel,
                  self._stopData.onDoubleWide,
                  self._stopData.reelHitCB,
                  self._stopData.extraStopDistances,
                  self._stopData.champagneModifierData
                );
                if (self._stopData.slamStop) {
                  self.handleSlamStop();
                }
              });

              self.stateMachine.switchState('IDLE');
            } else {
              self.reassignSlotMachine(self._activeSlotMachine, self._sourceSlotMachine);
              self.phase.reset();
            }
          });
        }
      }
    }

    onNewTransitionSymbol(reelId) {
      // if (reelId === 'reel0' && this._stopData.requested) {
      if (reelId === 'reel0' && this._stopData.switchLayoutNow === true) {
        //maybe not its own function, but another flag?
        this._stopData.switchLayoutNow = false;

        // all reels are aligned with gigablox, so it doesnt matter why reelId this is as they are all firing new symbols together
        this._sourceSlotMachine.sm.unsubscribeToNewSymbolEvent(this._boundNewSymbol);
        this.switchActiveLayout(this._stopData.layout, this._currentRowCount);

        // copy the source reels currently span symbols to target, so the time calculations can be correct on how long to spin for

        let numSymbolsTravelled = this._sourceSlotMachine.sm._currentMode.preInjectors[0]._numSymbolsInjected;
        for (let i = 0; i < this._activeSlotMachine.sm._currentMode.preInjectors.length; ++i) {
          this._activeSlotMachine.sm._currentMode.preInjectors[i]._numSymbolsInjected = numSymbolsTravelled;
        }

        this._activeSlotMachine.sm.infiniteSpin();

        if (this._stopData.requested) {
          this.stopActiveSlotMachine(
            this._stopData.reelLandCB,
            true,
            this._stopData.symbols,
            this._stopData.layout,
            this._stopData.above,
            this._stopData.below,
            this._stopData.spinCompleteCB,
            this._stopData.longSpinCB,
            this._stopData.winsPerReel,
            this._stopData.onDoubleWide,
            this._stopData.reelHitCB,
            this._stopData.extraStopDistances,
            this._stopData.champagneModifierData
          );

          // in order for transitioning of slot machines to align the slot machine must be forced through its state transitoin frames
          // so it starts spinning next frame. Update 0 is fine as we are only interested in moving through states and not moving the
          // symbols by frame delta
          while (this._activeSlotMachine.sm.reels[0].stateMachine.ActiveStateName !== 'SPIN_TO_TARGET') {
            this._activeSlotMachine.sm.update(0);
          }
        }

        // now move the reel by the same amount that the transtion has moved this frame to keep them aligned...
        this._activeSlotMachine.sm.update(this._sourceSlotMachine.sm.reels[0]._deltaTime);

        if (this._stopData.transitionCallbackStarted) {
          this._stopData.transitionCallbackStarted();
        }
      }
      // if (reelId === 'reel0' && this._stopData.requested) {
      //   // can allow slam stop now?!?!
      //   if (this._stopData.slamStop) {
      //     this.handleSlamStop();
      //   }
      // }
    }

    convertLayoutToString(gigabloxLayout, appertureHeight) {
      let strKey = 'SM-';
      let numElements = gigabloxLayout.length;
      for (let i = 0; i < numElements; ++i) {
        strKey += gigabloxLayout[i].toString();
        if (i < numElements - 1) strKey += '_';
      }
      return strKey + '-' + appertureHeight;
    }

    selectSlotMachine(gigabloxLayout, appertureHeight) {
      this._currentRowCount = appertureHeight;
      console.log('---- switching to gigablox layout: ' + JSON.stringify(gigabloxLayout));
      let stringRespresentation = this.convertLayoutToString(gigabloxLayout, appertureHeight);
      if (!this._slotMachineMap.hasOwnProperty(stringRespresentation)) {
        this.createNewSlotMachine(gigabloxLayout, stringRespresentation, appertureHeight);
        console.log('---- switched to new gigablox layout: ' + stringRespresentation);
      } else {
        console.log('SM with layout already created: ' + stringRespresentation);
      }
      this._activeSlotMachine.sm = resourceManager.getController(stringRespresentation);
      this._activeSlotMachine.parent = this._slotMachineMap[stringRespresentation];
      this._activeSlotMachine.layout = gigabloxLayout;

      let numReels = 5;

      this._activeSlotMachine.bounds = {
        x: this._reelVisualTemplateData.clipRect.x,
        y: this._reelVisualTemplateData.clipRect.y,
        width: numReels * this._reelVisualTemplateData.clipRect.width + 4,
        height: this._activeSlotMachine.sm.getMinSymbolSpacing(0) * appertureHeight + 8,
      };

      //  this._activeSlotMachine.parent.y = -offset;
      this.resetSlotParentPosition();

      this.enableSlotMachine(this._activeSlotMachine);
    }

    getCurrentLayout() {
      return this._activeSlotMachine.layout;
    }

    dimSymbol(reel, row, showDim, time) {
      this._activeSlotMachine.sm.dimSymbol(reel, row, showDim, time);
    }

    dimSymbols(symbols, showDim, time) {
      this._activeSlotMachine.sm.dimSymbols(symbols, showDim, time);
    }

    dimSymbolsOnReels(reels, showDim, time) {
      this._activeSlotMachine.sm.dimSymbolsOnReels(reels, showDim, time);
    }

    dimAllSymbols(showDim, time) {
      this._activeSlotMachine.sm.dimAllSymbols(showDim, time);
    }

    clearSplitBlocks() {}

    addAppertureSymbol(windowSymbols, blockInfo) {
      // add the preapperture symbol(should always be 0)
      for (let i = 0; i < blockInfo.length; ++i) {
        if (blockInfo[i][0].blockSize > 1 && blockInfo[i][0].offset > 0) {
          windowSymbols[i].symbols.push({ value: blockInfo[i][0].symId });
        } else {
          windowSymbols[i].symbols.push({ value: 0 });
        }
      }
    }

    addAppertureSymbolRandom(windowSymbols, preInjectors) {
      for (let i = 0; i < windowSymbols.length; ++i) {
        let topSymbol = windowSymbols[i][0];
        let preappertureSymbol = -1;
        do {
          preappertureSymbol = preInjectors[i].getRandomSymbol([], 1, -1);
        } while (topSymbol === preappertureSymbol);
        windowSymbols[i].symbols.push({ value: preappertureSymbol });
      }
    }

    setInitialSymbols(startingSymbols) {
      this._initialSymbols = JSON.parse(JSON.stringify(startingSymbols));
      let layout = [];
      let runningCount = 0;

      for (let i = 0; i < startingSymbols.length; ++i) {
        let linkedReels = [];
        for (let j = 0; j < startingSymbols[i].layout; ++j, ++runningCount) {
          linkedReels.push(runningCount);
        }
        layout.push(linkedReels);
      }

      let simpleWindowSymbols = [];
      for (let i = 0; i < startingSymbols.length; ++i) {
        let simpleReelSymbols = [];
        for (let j = 0; j < startingSymbols[i].symbols.length; ++j) {
          simpleReelSymbols.push(startingSymbols[i].symbols[j].value);
        }
        simpleWindowSymbols.push(simpleReelSymbols);
      }

      this._windowBlockInfo = this.calcWindowBlockInfo(simpleWindowSymbols, layout);

      this.selectSlotMachine(layout, simpleWindowSymbols[0].length);
      this.addAppertureSymbol(startingSymbols, this._windowBlockInfo);
      this.setStartingSymbols(startingSymbols, this._activeSlotMachine.sm);

      // populate the pre symbols with valid symbol info
      // so we dont see a wall of 10's going past
      this.populatePreSymbolsWithRandom(layout);

      this.unveilClipRect(this._activeSlotMachine.parent, 1, this._activeSlotMachine.bounds);
    }

    setStartingSymbols(startingSymbols, sm) {
      for (var i = 0; i < sm.reels.length; ++i) {
        var startingReelSymbols = startingSymbols[i].symbols;
        for (let j = 0; j < startingReelSymbols.length; ++j) {
          sm.setReelSymbol(i, j, startingReelSymbols[j].value);
        }
      }
    }

    setReelSymbol(reel, row, symbol) {
      this._activeSlotMachine.sm.setReelSymbol(reel, row, symbol);
    }

    unassignSlotMachine(sm) {
      sm.sm = undefined;
      sm.parent = undefined;
      sm.layout = [];
    }

    reassignSlotMachine(source, target) {
      target.sm = source.sm;
      target.parent = source.parent;
      target.layout = source.layout;
      this.unassignSlotMachine(source);
    }

    infiniteSpin() {
      console.log('gigabloxFactory - START SPIN');
      this.disableSymbolHitAreas();
      this.timeSpinStarted = performance.now();
      this._receivedTargetPositions = false;
      this._activeSlotMachine.sm.infiniteSpin();
    }

    disableSymbolHitAreas() {
      const paytablePopup = resourceManager.get('slotContainer:paytablePopup:PaytablePopup');
      paytablePopup.hide();

      const reels = this.getReelVisuals();
      for (let i = 0; i < reels.length; i++) {
        reels[i].disableSymbolHitAreas();
      }
    }

    enableSymbolHitAreas() {
      const reels = this.getReelVisuals();
      if (reels) {
        for (let i = 0; i < reels.length; i++) {
          reels[i].enableSymbolHitAreas();
        }
      }
    }

    handleSlamStop() {
      if (this._receivedTargetPositions) {
        this._activeSlotMachine.sm.slamStop();
        this.stateMachine.switchState('IDLE');
      } else {
        this._slamStopRequested = true;
      }
    }

    doSlamStop() {
      this.handleSlamStop();
    }

    areLayoutsEqual(arr1, arr2) {
      function areArraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;

        for (let i = 0; i < arr1.length; ++i) {
          if (arr1[i] !== arr2[i]) return false;
        }
        return true;
      }
      if (arr1.length !== arr2.length) return false;

      for (let i = 0; i < arr1.length; ++i) {
        if (!areArraysEqual(arr1[i], arr2[i])) return false;
      }
      return true;
    }

    spinCompleteCB(externalCB) {
      const diff = performance.now() - this.timeSpinStarted;
      console.log(`gigabloxFactory - SPIN FINISHED - ${diff}ms`);
      this._receivedTargetPositions = false;
      this._slamStopRequested = false;
      this._stopData.requested = false;
      this._activeSlotMachine.sm.setLoggingEnabled(false);
      let numReels = this._activeSlotMachine.sm.reels.length;
      for (let i = 0; i < numReels; ++i) {
        this._activeSlotMachine.sm._reelVisuals[i].redraw();
      }
      this.unsubscribeToReelsLandedEvent(this._activeSlotMachine.sm, this._stopData.reelLandCB);
      this.unsubscribeToReelsHitEvent(this._activeSlotMachine.sm, this._stopData.reelHitCB);
      externalCB();
    }

    convertGlobalReelToLocalOnActive(globalReel) {
      return this.globalReelToLocalReel(globalReel, this._activeSlotMachine.layout);
    }

    globalReelToLocalReel(globalReel, linkedReels) {
      for (let i = 0; i < linkedReels.length; ++i) {
        if (linkedReels[i].indexOf(globalReel) !== -1) {
          return i;
        }
      }
      return null;
    }

    getSymbolsOnReel(reelId) {
      return this._activeSlotMachine.sm.getSymbolsOnReel(reelId);
    }

    localReelToGlobalReel(localReel, linkedReels) {
      return linkedReels[localReel][0];
    }

    convertLocalReelToGlobalOnActive(localReel) {
      return this.localReelToGlobalReel(localReel, this._activeSlotMachine.layout);
    }

    getBiggestBlock(gigabloxLayout) {
      let res = 0;
      for (let i = 0; i < gigabloxLayout.length; ++i) {
        let blockSize = gigabloxLayout[i].length;
        res = Math.max(blockSize, res);
      }
      return res;
    }

    getBiggestBlockReelIndex(gigabloxLayout, blockSize) {
      let res = { globalIdx: 0, localIdx: 0 };

      for (let i = 0; i < gigabloxLayout.length; ++i) {
        let thisBlockSize = gigabloxLayout[i].length;
        if (thisBlockSize === blockSize) {
          return res;
        } else {
          res.globalIdx += thisBlockSize;
          res.localIdx++;
        }
      }
      return { globalIdx: -1, localIdx: -1 };
    }

    // return array of how to grow the reels.
    // biggestBlockSizeThisLayout: size of the block to grow to
    // startReelGlobal: assumes the reels are always 6 in size
    // layout the intermediate layouts
    calculateGrowData(gigabloxLayout) {
      // check for the only layout where it is possible to have two grows (3x3 and 3x3)
      if (gigabloxLayout.length === 2 && gigabloxLayout[0].length === 3) {
        return [
          { blockSize: 3, startReelGlobal: 3, layout: [[0], [1], [2], [3, 4, 5]] },
          {
            blockSize: 3,
            startReelGlobal: 0,
            layout: [
              [0, 1, 2],
              [3, 4, 5],
            ],
          },
        ];
      }

      let numReelsGlobal = 5; // FFS!!!
      let smallestBlockSizeToGrow = 3; // we dont grows anything smaller than a 3 gigablox
      let biggestBlockSizeThisLayout = this.getBiggestBlock(gigabloxLayout);
      let globalReelIndex = this.getBiggestBlockReelIndex(gigabloxLayout, biggestBlockSizeThisLayout).globalIdx;
      let leftmostGlobalPos = globalReelIndex;
      let rightmostGlobalPos = leftmostGlobalPos + biggestBlockSizeThisLayout;
      let wiggleRoomInclusive = biggestBlockSizeThisLayout - smallestBlockSizeToGrow;
      let wiggleRoomExclusive = wiggleRoomInclusive + 1;
      let startingGrowGlobalPos = leftmostGlobalPos + Math.floor(Math.random() * wiggleRoomExclusive);
      if (startingGrowGlobalPos + smallestBlockSizeToGrow > numReelsGlobal) {
        startingGrowGlobalPos = numReelsGlobal - (smallestBlockSizeToGrow + 1);
      }

      let res = [];
      for (let i = smallestBlockSizeToGrow; i <= biggestBlockSizeThisLayout; ++i) {
        // how many grows will there be before finished (including final layout)
        let preBlock = startingGrowGlobalPos - leftmostGlobalPos;
        let postBlock = rightmostGlobalPos - (startingGrowGlobalPos + i);
        let numIntermediateBlocksNeeded = biggestBlockSizeThisLayout - i; // how many 1x1 are needed for biggest block to grow into

        let layout = [];
        for (let localReelId = 0, globalReelId = 0; localReelId < gigabloxLayout.length; ++localReelId) {
          if (globalReelId === globalReelIndex) {
            // if this isnt the final block size, insert a single gigablox cell in it place.
            // So if we are growing to a 4x4 we will do this via a 1x1 and 3x3 and then grow that to 4x4
            for (let j = 0; j < preBlock; ++j) {
              layout.push([globalReelId + j]);
            }
            globalReelId += preBlock; // move by how much much single blocks we have grown in its place

            // the actual intermediate block that will be grown (so the 3x3 if growing to 4x4)
            let blockData = [];
            for (let j = 0; j < i; ++j) {
              blockData.push(globalReelId + j);
            }
            globalReelId += i;
            layout.push(blockData);

            for (let j = 0; j < postBlock; ++j) {
              layout.push([globalReelId + j]);
            }
            globalReelId += postBlock; // move by how much much single blocks we have grown in its place
          } else {
            layout.push(gigabloxLayout[localReelId]);
            globalReelId += gigabloxLayout[localReelId].length;
          }
        }
        res.push({ blockSize: i, startReelGlobal: startingGrowGlobalPos, layout: layout });

        if (i < biggestBlockSizeThisLayout) {
          let canGoLeft = startingGrowGlobalPos > leftmostGlobalPos;
          let canGoRight = startingGrowGlobalPos + i + 1 <= rightmostGlobalPos;

          if (canGoLeft && canGoRight) {
            canGoLeft = Math.random() < 0.5;
            canGoRight = !canGoLeft;
          }
          if (canGoLeft) {
            startingGrowGlobalPos -= 1;
          }
        } else {
          startingGrowGlobalPos = leftmostGlobalPos;
        }
      }

      return res;
    }

    getReelBlockInfo(reelId) {
      return this._windowBlockInfo[reelId];
    }

    // // returns array of starting rows (between 0 and 5 inclusive) for a blocks and how many rows are in this block
    // analyseBlocksOnReel(reel, blockSize, startingReelId) {
    //   // if we have an array looking like [2, 2, 2, 5, 5]
    //   // it thinks the 3rd 2 is split in half, where its the 1st one which needs to look like this
    //   // below is WRONG
    //   // [
    //   //   { row: 0, count: 2, symId: 2, blockSize: 2, startingGlobalReelId: 1, offset: 0 },
    //   //   { row: 2, count: 1, symId: 2, blockSize: 2, startingGlobalReelId: 1, offset: 0 },
    //   //   { row: 3, count: 2, symId: 5, blockSize: 2, startingGlobalReelId: 1, offset: 0 },
    //   // ];
    //   // it should look like
    //   // [
    //   //   { row: 0, count: 1, symId: 2, blockSize: 2, startingGlobalReelId: 1, offset: 0 },
    //   //   { row: 1, count: 2, symId: 2, blockSize: 2, startingGlobalReelId: 1, offset: 0 },
    //   //   { row: 3, count: 2, symId: 5, blockSize: 2, startingGlobalReelId: 1, offset: 0 },
    //   // ];

    //   // if we go backwards? would that fix it?
    //   // not sure backwards would help, if we had [2, 2, 5, 5, 5] we would end up in the same situation

    //   // how can we detect the pattern?
    //   // count number of same symbols starting from 0?
    //   // so the above example would give [3,2]
    //   // if 1st element is > blockSize then thats our split?
    //   // also bonusIDS have a blockSize of 1

    //   let res = [];
    //   for (let i = 0; i < reel.length; ) {
    //     let symId = reel[i];
    //     let count = 1;

    //     for (let j = 1; j < blockSize && i + j < reel.length; ++j) {
    //       if (reel[i + j] === symId) {
    //         ++count;
    //       } else {
    //         break;
    //       }
    //     }

    //     let offset = i === 0 ? blockSize - count : 0;

    //     res.push({
    //       row: i,
    //       count: count,
    //       symId: symId,
    //       blockSize: blockSize,
    //       startingGlobalReelId: startingReelId,
    //       offset: offset,
    //     });
    //     i += count;
    //   }
    //   return res;
    // }

    analyseBlocksOnReel(reel, blockSize, startingReelId) {
      let res = [];

      const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
      for (let i = 0; i < reel.length; ) {
        const symId = reel[i];

        // bonusID is always a single-row block, regardless of global blockSize
        const effectiveBlockSize = symId === bonusID ? 1 : blockSize;

        // Count the full consecutive run of the same symbol
        let runLength = 1;
        while (i + runLength < reel.length && reel[i + runLength] === symId) {
          runLength++;
        }

        let count;

        // --- Handle the only special case that caused bugs ---
        // If the run is longer than blockSize and we're at the very start of the reel,
        // the first block should take the "overflow" to align the rest of the run correctly.
        // Example: [2,2,2,5,5] with blockSize=2
        // runLength=3 → first block = 1, second block = 2
        if (i === 0 && runLength > effectiveBlockSize) {
          count = runLength % effectiveBlockSize; // overflow at start
          if (count === 0) count = effectiveBlockSize; // exact multiple case
        } else {
          // Normal case: take as much as fits in a block
          count = Math.min(runLength, effectiveBlockSize);
        }

        // Offset is only applied to the very first block of the reel
        const offset = i === 0 ? effectiveBlockSize - count : 0;

        res.push({
          row: i, // starting row index in reel
          count, // number of symbols in this block
          symId, // symbol id
          blockSize: effectiveBlockSize, // effective block size for this symbol
          startingGlobalReelId: startingReelId,
          offset, // only non-zero for first block
        });

        // Move forward by the number of symbols we just processed
        i += count;
      }

      return res;
    }

    doesActiveLayoutMatchThisLayout(gigabloxLayout) {
      let res = false;
      if (this.areLayoutsEqual(gigabloxLayout, this._activeSlotMachine.layout)) {
        res = true;
      }
      return res;
    }

    redraw() {
      const reels = this.getReelVisuals();
      for (let i = 0; i < reels.length; i++) {
        reels[i].redraw();
      }
    }

    stopReels(
      gigabloxLayout,
      symbols,
      above,
      below,
      spinCompleteCB,
      reelLandCB,
      transitionCallback,
      longSpinCB,
      winsPerReel,
      onDoubleWide,
      reelHitCB,
      extraStopDistances,
      champagneModifierData
    ) {
      let completeCB = this.spinCompleteCB.bind(this, spinCompleteCB);
      console.log('---- in stop reels');
      console.log('---- current gigablox layout is: ' + JSON.stringify(this._activeSlotMachine.layout));

      // unsubscribe from events (they get resubscribed in function below, otherwise we will trigger landEvents for the same reel multiple time, causing stop sounds building on top of each other sounding like volume has increased)
      // SRB
      // this will only work if the callback references are always the same -
      // check for ---WARNING: No Subscription to Unsubscribe from in the console logs
      // im unsubscribing when the reels stop, so these arent needed anymore, and will only produce the above message
      // this.unsubscribeToReelsLandedEvent(this._activeSlotMachine.sm, reelLandCB);
      // this.unsubscribeToReelsHitEvent(this._activeSlotMachine.sm, reelHitCB);

      this._transitionCallback = transitionCallback;

      // FYI, because the transition is done before hand now, this should always return true
      // at this point
      // leaving existing code for next games etc
      if (this.doesActiveLayoutMatchThisLayout(gigabloxLayout)) {
        console.log('----layouts equal');

        this._stopData.reelLandCB = reelLandCB;
        this._stopData.reelHitCB = reelHitCB;

        this.stopActiveSlotMachine(
          reelLandCB,
          true,
          symbols,
          gigabloxLayout,
          above,
          below,
          completeCB,
          longSpinCB,
          winsPerReel,
          onDoubleWide,
          reelHitCB,
          extraStopDistances,
          champagneModifierData
        );
        this._stopData.slamStop = this._slamStopRequested;
        if (this._stopData.slamStop) {
          this.handleSlamStop();
        }
      } else {
        console.log('----layouts different');
        this._stopData = {
          requested: true,
          layout: gigabloxLayout,
          symbols: symbols,
          above: above,
          below: below,
          spinCompleteCB: completeCB,
          reelLandCB: reelLandCB,
          slamStop: this._slamStopRequested,
          longSpinCB: longSpinCB,
          winsPerReel: winsPerReel,
          onDoubleWide: onDoubleWide,
          reelHitCB: reelHitCB,
          extraStopDistances: extraStopDistances,
          champagneModifierData: champagneModifierData,
        };

        console.log('----reassigning slot');
        this.reassignSlotMachine(this._activeSlotMachine, this._sourceSlotMachine);

        console.log('----getting biggest block');
        let biggestSlotSize = this.getBiggestBlock(gigabloxLayout);
        if (biggestSlotSize >= 4) {
          // SRB changed to 4 from 3 so we will never go in here
          console.log('----big block: ' + biggestSlotSize);

          this._growData = this.calculateGrowData(this._stopData.layout);

          // Edge case, if the intermediate grow data is same as current layout then we need to skip the first one.
          // Otherwise we end up disabling the current one which is the same as the intermediate one which causes that
          // to get disabled too. Visually there are no reels on the screen if this happens as they go invisible but does not cause an error.
          if (
            this._growData.length > 1 &&
            this.areLayoutsEqual(this._growData[0].layout, this._sourceSlotMachine.layout)
          ) {
            console.log('--removing intermeditate grow as it is same as source');
            this._growData.shift();
          }

          this.stateMachine.switchState('GROW');
        } else {
          console.log('----no big block');

          let doubleWides = [];
          for (let i = 0; i < gigabloxLayout.length; ++i) {
            if (gigabloxLayout[i].length === 2) {
              doubleWides.push(gigabloxLayout[i][0]);
            }
          }

          if (doubleWides.length > 0) {
            this._stopData.onDoubleWide = onDoubleWide;
            this._stopData.doubleWides = doubleWides;
          }

          this.stateMachine.switchState('TRANSITION');
        }
      }
    }

    popSymbols(popData, callback, injectNew, preCompiledInjectList) {
      const popSymbolsData = this._activeSlotMachine.sm.popSymbols(popData, callback, injectNew, preCompiledInjectList);
      const reels = this.getReelVisuals();

      // go through each reel, and look to see if any entire rows have been removed
      // there is an issue with an initial drop with symbol hanging over the bottom
      // all explode on that reel, but new symbols are the same as we removed,
      // so the calcBlockData is incorrectly calculated
      for (let i = 0; i < reels.length; i++) {
        if (reels[i]._blockSize > 1) {
          let count = 0;
          for (let k = 0; k < popData[i].length; k++) {
            if (popData[i][k] === true) {
              count++;
            }
          }
          if (count === popData[i].length) {
            const rsd = reels[i].getReelSpinnerData();
            const bottomSymbol = rsd._symbolData[rsd._currentAppertureHeight - 1].symId;
            const postSymbol = rsd._symbolData[rsd._postAppertureSymbolIdx].symId;
            if (bottomSymbol === postSymbol) {
              // we need to change it - dont need to check for bonus as we cant have them on same reel
              const symbolIndexesForAbove = Globals.ALLOWED_SYMBOLS.slice(0).filter((n) => n !== bottomSymbol);
              const randomId = symbolIndexesForAbove[Utils.randomNumberBetween(0, symbolIndexesForAbove.length - 1)];
              reels[i].setReelSymbol(rsd._postAppertureSymbolIdx, randomId);
            }
          }
        }
      }

      // because things have moved, we need to recalculate a few things
      // so they are drawn correctly
      this.recalculateWindowBlockInfo();
      for (let i = 0; i < reels.length; i++) {
        reels[i].recalculateBlockData();
        if (reels[i]._blockSize > 1) {
          reels[i].updateClipRects();
        }
      }
      return popSymbolsData;
    }

    dropSymbols(dropData, callback) {
      this._activeSlotMachine.sm.dropSymbols(dropData, callback);
    }

    wipeReels(newLayout, newWindow, callback) {
      this._wipeCB = callback;
      this.reassignSlotMachine(this._activeSlotMachine, this._sourceSlotMachine);
      this.selectSlotMachine(newLayout);
      this.setStartingSymbols(newWindow, this._activeSlotMachine.sm);
      this._activeSlotMachine.parent.position.set(0, -576);
      this.stateMachine.switchState('WIPE');
      this.moveSlotMachineToFront(this._sourceSlotMachine.parent);
    }

    update(delta) {
      this.stateMachine.update(delta);
    }

    moveSlotMachineToFront(reelsParent) {
      this._reelVisualParent.setChildIndex(reelsParent, this._reelVisualParent.children.length - 1);
    }

    unveilClipRect(obj, progress, bounds) {
      if (obj.mask) {
        obj.mask.clear();
        obj.mask.beginFill(0x000000, 0);
        obj.mask.drawRect(bounds.x, bounds.y, bounds.width, bounds.height * progress);
        obj.mask.endFill();
      }
    }

    enableSlotMachine(sm) {
      sm.sm.enable();
      sm.parent.visible = true;
      sm.sm.selectReelMode(this._currentMode);
    }

    disableSlotMachine(sm) {
      sm.sm.disable();
      sm.parent.visible = false;
    }
    /*
        sanityCheckCallbacks(){
            for (let prop in this._slotMachineMap){
                if (this._slotMachineMap.hasOwnProperty(prop)){
                    let sm = resourceManager.getController(prop);
                    if (sm._reelLandedCallbacks.length > 6){
                        console.log("SLOT MACHINE STILL HAS CALLBACKS: " + prop);
                    }

                }
            }
        }
*/
    fullyDiscardSlotMachine(sm) {
      sm.sm.abortSpin();
      sm.sm.update(); // gives abort time to move in to idle, otherwise flag wont get reset
      this.disableSlotMachine(sm);
      this.unassignSlotMachine(sm);
    }

    abortSpin() {
      if (this._activeSlotMachine && this._activeSlotMachine.sm && this._stopData && this._stopData.reelLandCB) {
        this.unsubscribeToReelsLandedEvent(this._activeSlotMachine.sm, this._stopData.reelLandCB);
      }
      if (this._activeSlotMachine && this._activeSlotMachine.sm && this._stopData && this._stopData.reelHitCB) {
        this.unsubscribeToReelsHitEvent(this._activeSlotMachine.sm, this._stopData.reelHitCB);
      }
      this.fullyDiscardSlotMachine(this._activeSlotMachine);
      this.setInitialSymbols(this._initialSymbols);
    }

    getBigBloxStaggerTimer() {
      let delayMin = 1000;
      let stagger = 200;
      let delayBlockOffset = this._growData.length > 0 ? (this._growData[0].blockSize - 3) * stagger : 0;

      if (delayBlockOffset === 0 && this._stopData.symbols.length === 1) {
        // is this a 6x6 if so no need to stagger as it cant get any bigger
        return 0;
      }

      return delayMin + delayBlockOffset;
    }

    getSymbolPosition(reel, row, useLocalLayout) {
      if (useLocalLayout) {
      } else {
        let scale = this.getCurrentScale();
        let res = this.getReelScreenPosition(reel);
        res.x += this._activeSlotMachine.parent.position.x;
        res.y +=
          row * this._reelVisualTemplateData.minSymbolSpacing * scale + this._activeSlotMachine.parent.position.y;

        return res;
      }
    }

    getMinSymbolSpacing() {
      return this._activeSlotMachine.sm.getMinSymbolSpacing(0);
    }

    copySymbolIdsFromSourceToActive(numReels, sourceStartRow, targetStartRow, numSymsToCopy, sourceSlot, activeSlow) {
      let startingSymbols = [];
      for (let reelId = 0; reelId < numReels; ++reelId) {
        let rows = [];

        for (
          let sourceRow = sourceStartRow, targetRow = targetStartRow;
          sourceRow < sourceStartRow + numSymsToCopy;
          ++sourceRow, ++targetRow
        ) {
          let symId = sourceSlot.getSymbolId(reelId, sourceRow);
          activeSlow.setReelSymbol(reelId, targetRow, symId);
          rows.push({ value: symId });
        }
        startingSymbols.push({ symbols: rows });
      }
      return startingSymbols;
    }

    splitWinningBlocks(winningLines, callback) {
      let numRows = 8; // need to serialise this
      let uniqueBlocks = [];
      let linkedReels = this._activeSlotMachine.layout;
      for (let i = 0; i < winningLines.length; ++i) {
        let winline = winningLines[i];
        let positions = winline.positions;
        for (let j = 0; j < positions.length; ++j) {
          let reel = positions[j].reel;
          let row = positions[j].row;

          // which block does this fall in to
          for (let k = 0; k < this._windowBlockInfo.length; ++k) {
            let blocksInfo = this._windowBlockInfo[k];
            for (let l = 0; l < blocksInfo.length; ++l) {
              let blockInfo = blocksInfo[l];
              if (blockInfo.blockSize < 2) continue;
              let startingGlobalId = this.localReelToGlobalReel(blockInfo.startingGlobalReelId, linkedReels);

              // its on this reel
              if (reel >= startingGlobalId && reel <= startingGlobalId + blockInfo.blockSize - 1) {
                let startingRow = blockInfo.row;
                if (row >= startingRow && row <= startingRow + blockInfo.count - 1) {
                  // if its a new block
                  let mergedCell = startingGlobalId * numRows + startingRow;

                  if (uniqueBlocks.indexOf(mergedCell) === -1) {
                    uniqueBlocks.push(mergedCell);
                  }
                }
              }
            }
          }
        }
      }

      let blocks = [];
      for (let i = 0; i < uniqueBlocks.length; ++i) {
        let block = uniqueBlocks[i];
        let reel = Math.floor(block / numRows);
        let row = block % numRows;
        blocks.push({ reel: this.globalReelToLocalReel(reel, linkedReels), row: row });
      }

      this.splitBlocks(blocks, callback);
    }

    splitBlocks(blockData, callback) {}

    subscribeToReelsLandedEvent(who, what) {
      // if (Object.keys(this._trackLandEvents).length > 0) {
      //   console.log('Tracked land events > 0');
      //   for (let prop in this._trackLandEvents) {
      //     if (this._trackLandEvents.hasOwnProperty(prop)) {
      //       console.log(prop);
      //     }
      //   }
      // }
      this._trackLandEvents[who.name] = what;
      who.subscribeToReelsLandedEvent(what);
    }

    unsubscribeToReelsLandedEvent(who, what) {
      delete this._trackLandEvents[who.name];
      who.unsubscribeToReelsLandedEvent(what);
      // if (Object.keys(this._trackLandEvents).length > 0) {
      //   console.log('Tracked land events > 0');
      //   for (let prop in this._trackLandEvents) {
      //     if (this._trackLandEvents.hasOwnProperty(prop)) {
      //       console.log(prop);
      //     }
      //   }
      // }
    }

    subscribeToReelsHitEvent(who, what) {
      // if (Object.keys(this._trackHitEvents).length > 0) {
      //   console.log('Tracked hit events > 0');
      //   for (let prop in this._trackHitEvents) {
      //     if (this._trackHitEvents.hasOwnProperty(prop)) {
      //       console.log(prop);
      //     }
      //   }
      // }
      this._trackHitEvents[who.name] = what;
      who.subscribeToReelsHitEvent(what);
    }

    unsubscribeToReelsHitEvent(who, what) {
      delete this._trackHitEvents[who.name];
      who.unsubscribeToReelsHitEvent(what);
      // if (Object.keys(this._trackHitEvents).length > 0) {
      //   console.log('Tracked hit events > 0');
      //   for (let prop in this._trackHitEvents) {
      //     if (this._trackHitEvents.hasOwnProperty(prop)) {
      //       console.log(prop);
      //     }
      //   }
      // }
    }

    /*
        splitblock(blockData){
            for (let i = 0; i < blockData.length; ++i){
                let block = blockData[i];
                let reel = block.reel;
                let blockSize = block.size;
                let windowBlockInfoCopy = JSON.parse(JSON.stringify(this._windowBlockInfo));
                windowBlockInfoCopy[reel] = [windowBlockInfoCopy[reel]["0"] ];

                for (let j = 1; j < 4; ++j){
                    windowBlockInfoCopy[reel].push({
                        blockSize: 1,
                        count: 1,
                        offset: 0,
                        row: j,
                        symId: 9,
                        startingGlobalReelId: reel
                    });
                }
                this._windowBlockInfo = windowBlockInfoCopy;
                this._activeSlotMachine.sm._reelVisuals[reel].redraw();
            }
        }
        */

    transition(gigabloxLayout, callbackWhenStarted, callbackWhenFinished) {
      this._stopData = {
        requested: false,
        switchLayoutNow: true,
        layout: gigabloxLayout,
        onDoubleWide: false,
        transitionCallbackStarted: callbackWhenStarted,
        transitionCallbackFinished: callbackWhenFinished,
      };
      this._boundNewSymbol = this.onNewTransitionSymbol.bind(this);
      this.reassignSlotMachine(this._activeSlotMachine, this._sourceSlotMachine);
      this.stateMachine.switchState('TRANSITION');
    }

    // this function is purely for the golden claw modifier
    transitionWhenStopped(gigabloxLayout, symbols, updateBlockDataBy, callbackWhenFinished) {
      this.reassignSlotMachine(this._activeSlotMachine, this._sourceSlotMachine);

      // all reels are aligned with gigablox, so it doesnt matter why reelId this is as they are all firing new symbols together
      this.switchActiveLayout(gigabloxLayout, this._currentRowCount);

      // we arent moving
      // copy the source reels currently span symbols to target, so the time calculations can be correct on how long to spin for
      this._activeSlotMachine.sm.forceSymbolsTo(symbols);
      this.recalculateWindowBlockInfo();

      const reelVisuals = this.getReelVisuals();
      for (let i = 0; i < reelVisuals.length; i++) {
        const reelVisual = reelVisuals[i];
        const blockData = reelVisual.recalculateBlockData();
        if (i === reelVisuals.length - 1 && updateBlockDataBy > 0) {
          // last reel
          // updateBlockDataBy > 0 means golden claw and we have to render the post symbols
          // going past
          let nextBlockData = blockData[Globals.NUM_ROWS - 1] + 1;
          nextBlockData %= reelVisual._blockSize; // just in case, but we should never need to adjust at this point
          for (let k = 0; k < updateBlockDataBy; k++) {
            const offset =
              reelVisual._reelSpinnerData._maxAppertureHeight + reelVisual._reelSpinnerData._preAppertureSymbols;
            blockData[k + offset] = nextBlockData;
            nextBlockData++;
            nextBlockData %= reelVisual._blockSize;
          }
        }
        reelVisuals[i].redraw(false);
      }

      this._activeSlotMachine.sm.update(0);

      this.unveilClipRect(this._activeSlotMachine.parent, 1.0, this._activeSlotMachine.bounds);
      this.fullyDiscardSlotMachine(this._sourceSlotMachine);

      if (callbackWhenFinished) {
        callbackWhenFinished();
      }
    }

    state_transition() {
      if (this.phase.enter()) {
        this._sourceSlotMachine.sm.subscribeToNewSymbolEvent(this._boundNewSymbol);
      }

      if (this.phase.hold()) {
        // unveil target
        if (this._activeSlotMachine.sm) {
          if (this._stopData.onDoubleWide) {
            this._stopData.onDoubleWide(this._stopData.doubleWides);
            this._stopData.onDoubleWide = undefined;
          }

          let progress =
            this._activeSlotMachine.sm.reels[this._activeSlotMachine.sm.reels.length - 1].getDistanceTravelled() /
            this._activeSlotMachine.bounds.height;
          this.unveilClipRect(this._activeSlotMachine.parent, Math.min(1.0, progress), this._activeSlotMachine.bounds);
          if (progress >= 1.0) {
            this.stateMachine.switchState('IDLE');
          }
        }
      }

      if (this.phase.exit()) {
        this.unveilClipRect(this._activeSlotMachine.parent, 1.0, this._activeSlotMachine.bounds);
        this.fullyDiscardSlotMachine(this._sourceSlotMachine);
        if (this._stopData.transitionCallbackFinished) {
          this._stopData.transitionCallbackFinished();
        }
      }
    }

    state_grow() {
      if (this.phase.enter()) {
        console.log('----in state grow');
        console.log('----grow size is: ' + this._growData.length);
      }

      let delayTime = this.getBigBloxStaggerTimer();
      if (this.phase.timed(delayTime)) {
      }
      if (this.phase.once()) {
        console.log('----first phase');

        let growData = this._growData.shift();
        console.log('----grow size is: ' + this._growData.length);

        console.log('----creating bind');
        this._boundNewSymbolForGrow = this.onNewTransitionSymbolForGrow.bind(this, growData.layout, growData);

        console.log('----subscribing to new symbol event');
        this._sourceSlotMachine.sm.subscribeToNewSymbolEvent(this._boundNewSymbolForGrow);
      }

      if (this.phase.hold()) {
        // unveil target
        if (this._activeSlotMachine.sm) {
          let progress =
            this._activeSlotMachine.sm.reels[0].getDistanceTravelled() / this._activeSlotMachine.bounds.height;
          this.unveilClipRect(this._activeSlotMachine.parent, Math.min(1.0, progress), this._activeSlotMachine.bounds);
          if (progress >= 1.0) {
            this.phase.step();
          }
        }
      }
      if (this.phase.once()) {
        console.log('----last phase');
      }
    }

    state_wipe() {
      if (this.phase.timed(300)) {
        this._activeSlotMachine.parent.position.set(0, -576 * (1 - this.phase.Progress));
      }

      if (this.phase.once()) {
        this._activeSlotMachine.parent.position.set(0, 0);
      }

      if (this.phase.timed(200)) {
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this._activeSlotMachine.parent.position.set(0, 0);
        this.moveSlotMachineToFront(this._activeSlotMachine.parent);
        this.fullyDiscardSlotMachine(this._sourceSlotMachine);
        this._wipeCB();
      }
    }

    updateClipRect(y, height, slotMachine) {
      let numReels = slotMachine.sm.reels.length;
      for (let i = 0; i < numReels; ++i) {
        slotMachine.sm._reelVisuals[i].updateClipRect(y, height);
      }
    }

    setParentScale(parent, scale, bounds, offset) {
      parent.scale.set(scale);
      parent.position.x = (bounds.width - bounds.width * scale) / 2;
      parent.position.y = -offset + (bounds.height - bounds.height * scale);
    }

    getReelVisuals() {
      return this._activeSlotMachine?.sm?._reelVisuals;
    }

    recalculateWindowBlockInfo(allSymbols = false) {
      const currentSymbols = [];
      const reelVisuals = this.getReelVisuals();
      for (let reel = 0; reel < reelVisuals.length; reel++) {
        currentSymbols[reel] = reelVisuals[reel].getSymbolsInView();
        const symbolData = reelVisuals[reel].getSymbolData();
        const post = symbolData[Globals.NUM_ROWS + Globals.NUM_PRE_APPERATURE_SYMBOLS];
        currentSymbols[reel].push(post.symId);
      }
      this._windowBlockInfo = this.calcWindowBlockInfo(currentSymbols, this.getCurrentLayout());
      return this._windowBlockInfo;
    }

    state_shrink_rows() {
      if (this.phase.enter()) {
        this._inGrowTransition = true;
        if (this._changeWindowSizeData.winEvent) {
          this.clearSplitBlocks();
        }
        this.dimAllSymbols(false, 0.0);
        this.unsubscribeToReelsLandedEvent(this._activeSlotMachine.sm, this._stopData.reelLandCB);
        this.unsubscribeToReelsHitEvent(this._activeSlotMachine.sm, this._stopData.reelHitCB);
      }
      if (this.phase.timed(1000)) {
        let sourceAppertureHeight = this._activeSlotMachine.sm.reels[0].getCurrentAppertureHeight();
        let minSpacing = this._activeSlotMachine.sm.getMinSymbolSpacing(0);
        let offset = (sourceAppertureHeight - 4) * minSpacing; // magic number 4, it is the default number of rows before they start growing
        let delta = minSpacing * this.phase.Progress;
        let scale = this._changeWindowSizeData.startData.scale;
        let targetScale = this._changeWindowSizeData.endData.scale;
        let scaleDelta = targetScale - scale;
        let scaleProgress = this.phase.Progress * scaleDelta;
        //    let moveUpBy = offset * (1-this.phase.Progress);
        let moveUpBy =
          this._changeWindowSizeData.startData.y +
          (this._changeWindowSizeData.endData.y - this._changeWindowSizeData.startData.y) * this.phase.Progress;
        this.setParentScale(
          this._activeSlotMachine.parent,
          scale + scaleProgress,
          this._activeSlotMachine.bounds,
          offset - moveUpBy
        ); //560
        //    this.updateClipRect(moveUpBy, 840 - ((840 - 560) *this.phase.Progress), this._activeSlotMachine ); // previous height plus the progress of one grow amount
        this.updateClipRect(
          (sourceAppertureHeight - 4) * minSpacing * this.phase.Progress,
          sourceAppertureHeight * minSpacing - (sourceAppertureHeight - 4) * minSpacing * this.phase.Progress,
          this._activeSlotMachine
        ); // previous height plus the progress of one grow amount
        //this.updateClipRect((minSpacing-delta), ((this._currentRowCount-1) * minSpacing) + (minSpacing * this.phase.Progress), this._activeSlotMachine); // previous height plus the progress of one grow amount
      }
      if (this.phase.once()) {
        let minSpacing = this._activeSlotMachine.sm.getMinSymbolSpacing(0);
        let currentLayout = this.getCurrentLayout();
        this.reassignSlotMachine(this._activeSlotMachine, this._sourceSlotMachine);
        this.switchActiveLayout(currentLayout, this._currentRowCount);
        this.subscribeToReelsLandedEvent(this._activeSlotMachine.sm, this._stopData.reelLandCB);
        this.subscribeToReelsHitEvent(this._activeSlotMachine.sm, this._stopData.reelHitCB);
        this.unveilClipRect(this._activeSlotMachine.parent, 1, this._activeSlotMachine.bounds);
        let sourceAppertureHeight = this._sourceSlotMachine.sm.reels[0].getCurrentAppertureHeight();
        let startingSymbols = [];
        // grow
        if (sourceAppertureHeight < this._currentRowCount) {
          startingSymbols = this.copySymbolIdsFromSourceToActive(
            currentLayout.length,
            0,
            1,
            sourceAppertureHeight,
            this._sourceSlotMachine.sm,
            this._activeSlotMachine.sm
          );
          // preapperture of source begine symbol 0 for sctive
          for (let reelId = 0; reelId < currentLayout.length; ++reelId)
            startingSymbols[reelId].symbols.unshift({
              value: this._sourceSlotMachine.sm.getSymbolId(reelId, sourceAppertureHeight),
            });
        } // shrink
        else
          startingSymbols = this.copySymbolIdsFromSourceToActive(
            currentLayout.length,
            sourceAppertureHeight - this._currentRowCount,
            0,
            this._currentRowCount,
            this._sourceSlotMachine.sm,
            this._activeSlotMachine.sm
          );

        let simpleWindowSymbols = [];
        for (let i = 0; i < startingSymbols.length; ++i) {
          let simpleReelSymbols = [];
          let appertureHeight = this._activeSlotMachine.sm.reels[i].getCurrentAppertureHeight();
          for (let j = 0; j < appertureHeight; ++j) {
            simpleReelSymbols.push(startingSymbols[i].symbols[j].value);
          }
          simpleWindowSymbols.push(simpleReelSymbols);
        }
        this.setParentScale(
          this._activeSlotMachine.parent,
          this._changeWindowSizeData.endData.scale,
          this._activeSlotMachine.bounds,
          0
        );
        this._windowBlockInfo = this.calcWindowBlockInfo(simpleWindowSymbols, currentLayout);
        this.addAppertureSymbol(startingSymbols, this._windowBlockInfo);
        this.setStartingSymbols(startingSymbols, this._activeSlotMachine.sm);

        for (let i = 0; i < currentLayout.length; ++i) {
          this._activeSlotMachine.sm._reelVisuals[i].redraw();
        }

        this.fullyDiscardSlotMachine(this._sourceSlotMachine);
        this.updateClipRect(0, this._currentRowCount * minSpacing, this._activeSlotMachine);
        this.stateMachine.switchState('IDLE');
      }
      if (this.phase.exit()) {
        this._inGrowTransition = false;
        let minSpacing = this._activeSlotMachine.sm.getMinSymbolSpacing(0);
        this.updateClipRect(0, this._currentRowCount * minSpacing, this._activeSlotMachine); // previous height plus the progress of one grow amount
        this._changeWindowSizeData.callback();
      }
    }

    state_change_rows() {
      if (this.phase.enter()) {
        this._inGrowTransition = true;
      }

      if (this.phase.timed(1000)) {
        let minSpacing = this._activeSlotMachine.sm.getMinSymbolSpacing(0);
        let offset = (this._currentRowCount - 4) * minSpacing; // magic number 4, it is the default number of rows before they start growing
        let delta = minSpacing * this.phase.Progress;

        let scale = this._changeWindowSizeData.startData.scale;
        let targetScale = this._changeWindowSizeData.endData.scale;
        let scaleDelta = scale - targetScale;
        let scaleProgress = this.phase.Progress * scaleDelta;
        let moveDownBy =
          this._changeWindowSizeData.startData.y +
          (this._changeWindowSizeData.endData.y - this._changeWindowSizeData.startData.y) * this.phase.Progress;
        this.setParentScale(
          this._activeSlotMachine.parent,
          scale - scaleProgress,
          this._activeSlotMachine.bounds,
          offset - moveDownBy
        );
        this.updateClipRect(
          minSpacing - delta,
          (this._currentRowCount - 1) * minSpacing + minSpacing * this.phase.Progress,
          this._activeSlotMachine
        ); // previous height plus the progress of one grow amount
      }

      if (this.phase.once()) {
        let targetScale = this._changeWindowSizeData.endData.scale;
        console.log('Target Scale: ' + targetScale);

        console.log('Current Scale: ' + this._activeSlotMachine.parent.scale.x);

        console.log('=================');
        //    let minSpacing = this._activeSlotMachine.sm.getMinSymbolSpacing(0);
        //   this.updateClipRect(0, ((this._currentRowCount) * minSpacing), this._activeSlotMachine);

        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this._inGrowTransition = false;
        let minSpacing = this._activeSlotMachine.sm.getMinSymbolSpacing(0);
        this.updateClipRect(0, (this._currentRowCount - 1) * minSpacing + minSpacing, this._activeSlotMachine); // previous height plus the progress of one grow amount
        this._changeWindowSizeData.callback();
      }
    }
  }

  function getRequiredFiles() {
    let res = [];
    /* for (let i = 1; i <=6 ; ++i){
            let textureListsName = "symbols_" + i + "x" + i;
            var symbolsList = resourceManager.getConfiguration()[textureListsName];
            for (var prop in symbolsList) {
                if (typeof (symbolsList[prop]) === "object") {
                    // Add the first texture of each symbol
                    let texture = textureParser.getTextureList( symbolsList[prop].texture )[0];
                    res.push( texture.textureCacheIds[0] );
                }
            }
        }*/

    return res;
  }

  resourceManager.registerObjectType(
    'GigabloxFactory',
    function () {
      let maxBlockSize = 3; // should be data driven

      for (let i = 1; i <= maxBlockSize; ++i) {
        let jsonObj = {
          format: 'list',
          files: [],
        };

        let textureListsName = 'symbols_' + i + 'x' + i;
        var symbolsList = resourceManager.getConfiguration()[textureListsName];
        for (var prop in symbolsList) {
          if (typeof symbolsList[prop] === 'object') {
            // Add the first texture of each symbol
            let texture = textureParser.getTextureList(symbolsList[prop].texture)[0];
            jsonObj.files.push(texture.textureCacheIds[0].replace(ReflexLoader.rootResDir, ''));
          }
        }

        textureParser.addTextureList(textureListsName, jsonObj);
        textureParser.getTextureList(textureListsName);
      }

      return new GigabloxFactory();
    },
    function (json, gigabloxFactory) {
      gigabloxFactory.initialise(json);
    },
    getRequiredFiles
  );
})();
